import {debounce, throttle} from 'lodash';
import imgLoad from '../modules/images.js';
import announcementBar from '../modules/announcementBar';
import $ from 'jquery';

export default {
  viewportTop              : null,
  viewportBottom           : null,
  viewportTopFromBottom    : null,
  viewportBottomFromBottom : null,
  viewportHeight           : null,
  documentHeight           : null,
  previousViewPortTop      : null,
  scrolledUp               : false,

  options : {
    scrollUpSensitivity   : 20,
    scrollDownSensitivity : 50,
  },

  _bindEvents() {
    let debouncedResize = _.debounce(this.hasResized.bind(this), 200);
    let throttledScroll = _.throttle(this.hasScrolled.bind(this), 200);
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('scroll', throttledScroll);
    window.addEventListener('popstate', debouncedResize.cancel);
    window.addEventListener('popstate', throttledScroll.cancel);
    imgLoad.on('always', () => this.hasLoaded());
    // HACK
    // 1. refresh measurements after elements that don't emit events load
    // 2. Firefox chooses 1x lazy image initially, but seems to select the
    //    correct resolution after resize. Possible bug in lazysizes, using
    //    sizes=auto, no time to investigate.
    setTimeout( () => $(window).trigger('resize'), 2000); // TODO investigate and fix root of problem
  },

  init() {
    this._bindEvents();
    this.updateAll();
    this.assignClasses();
  },

  hasScrolled() {
    this.updatePositions();
    this.updateScrollDirection();
    this.assignClasses();
  },

  hasResized() {
    this.updateHeights();
    this.assignClasses();
  },

  hasLoaded() {
    this.updateHeights();
    this.assignClasses();
  },

  assignClasses() {
    const html = document.documentElement;

    // Front page only
    if ( document.body.classList.contains('body-front-page') ) {
      // shrink header after 100px
      if ( this.viewportTop > 100 ) {
        html.classList.add('ss-slim-header');
      } else {
        html.classList.remove('ss-slim-header');
      }
      // hide header after 200px, unless scrolledUp
      if ( this.viewportTop > 300 && !this.scrolledUp ) {
        html.classList.add('ss-hide-header');
      } else {
        html.classList.remove('ss-hide-header');
      }
    // All other pages
    } else {
      // hide header after 100px, unless scrolledUp
      if ( this.viewportTop > 200 && !this.scrolledUp ) {
        html.classList.add('ss-hide-header');
      } else {
        html.classList.remove('ss-hide-header');
      }
    }

    if ( announcementBar.initialized ) {
      announcementBar.toggle( this.viewportBottomFromBottom < 300 );
    }

  },

  updateScrollDirection() { // not included in updateAll()
    const scrollDiff = this.viewportTop - this.previousViewportTop;

    if ( scrollDiff < (-1 * this.options.scrollUpSensitivity) ) {
      this.scrolledUp = true;
    } else if ( scrollDiff > this.options.scrollDownSensitivity ) {
      this.scrolledUp = false;
    }
  },

  updateAll() {
    this.updateHeights();
    this.updatePositions();
  },

  updateHeights() {
    this.viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    this.documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.documentElement.clientHeight
    );
    this.updatePositionsFromBottom();
  },

  updatePositions() {
    this.updatePositionsFromTop();
    this.updatePositionsFromBottom();
  },

  updatePositionsFromTop() {
    this.previousViewportTop = this.viewportTop || 0;
    this.viewportTop = window.pageYOffset
      || (document.documentElement && document.documentElement.scrollTop)
      || document.body.scrollTop;
    this.viewportBottom = this.viewportTop + this.viewportHeight;
  },

  updatePositionsFromBottom() {
    this.viewportTopFromBottom = this.documentHeight - this.viewportTop;
    this.viewportBottomFromBottom = this.viewportTopFromBottom - this.viewportHeight;
  },

  logAll() {
    console.log('viewportTop              : '+this.viewportTop);
    console.log('viewportBottom           : '+this.viewportBottom);
    console.log('viewportTopFromBottom    : '+this.viewportTopFromBottom);
    console.log('viewportBottomFromBottom : '+this.viewportBottomFromBottom);
    console.log('viewportHeight           : '+this.viewportHeight);
    console.log('documentHeight           : '+this.documentHeight);
    console.log('previousViewPortTop      : '+this.previousViewPortTop);
    console.log('scrolledUp               : '+this.scrolledUp);
  }

}

  // ENHANCEMENT: make scroll breakpoints, absTop, absBottom
  //         so nearTop is a breakpoint
  //         or config like:
  //           slimHeader: {
  //             fromTop: 100
  //           }
  //           hideHeader: {
  //             fromTop: 200
  //           }
  //           showHeader: {
  //             scrollUp: 20
  //             fromTop: 100
  //           }
  //
  //           would require use of eval()... i think. maybe this is all insane
  //           but it should still be factored out...
  //
  //       ScrollWatcher class (singleton?)
  //         resizeDelay: 200,
  //         scrollDelay: 200,
  //
  //       ScrollScout class
  //         controlElement: 'html',
  //         containerElement: 'html', (this would really complicate things)
  //         classPrefix: 'ss-',
  //         watch: {
  //           className: {
  //             fromTop: null,
  //             fromBottom: null,
  //             scrollUp: null,
  //             scrollDown: null,
  //             method: 'or'
  //           }
  //         }
  //
  //         scrollWatcher.get('fromTop');
  //         scrollWatcher.get('fromBottom');
  //         scrollWatcher.get('scrollDistance');
  //         window.resize( _.debounce(this.refresh) );
